import { render, staticRenderFns } from "./GamanzaAvatar.vue?vue&type=template&id=2bf5b633&scoped=true"
import script from "./GamanzaAvatar.vue?vue&type=script&lang=js"
export * from "./GamanzaAvatar.vue?vue&type=script&lang=js"
import style0 from "./GamanzaAvatar.vue?vue&type=style&index=0&id=2bf5b633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5b633",
  null
  
)

export default component.exports